<template lang="pug">
v-container
  template.ma-2(v-if="contract && contract.is_offer")
    v-alert(type="info" text) Подтвердите намерения заключения договора оферты.
    p(v-if="readyContract.sum") Стоимость образовательных услуг составит
      strong.ml-2 {{ readyContract.sum }} руб.
    v-card.mx-2.sdo-card(max-height=300).overflow-auto
      v-card-text(v-html="readyContract.preview_document")
      div.py-2(v-intersect="onIntersect")
  template.ma-2(v-if="contract && !contract.is_offer")
    p.
      Ознакомьтесь с текстом договора об образовании, предусмотренного организаций.
      В случае если Вы согласны с условиями договора, подтвердите намерения заключения договора.
      В системе сразу будут присвоены системные реквизиты договора, однако непосредственное
      заключение договора будет осуществляться во взаимодействии с представителем организации,
      контакты которого вы видите ниже
    v-list
      v-list-item
        v-list-item-content
          v-list-item-title +7-913-468-55-55
          v-list-item-subtitle телефон
      v-list-item
        v-list-item-content
          v-list-item-title blablabla@blabla.bla
          v-list-item-subtitle E-mail
      v-list-item
        v-list-item-content.
          Другая информация для связи
            другая информация для связи
              другая информация для связи  другая информация для связи...
    v-btn(color="secondary" @click="download") Ознакомиться с договором
  template(v-if="noStep")
    v-checkbox.ml-2(
      v-model="checkbox"
    )
      template(#label)
        span(v-if="noStep")
          span Даю согласие на обработку персональных данных в соответствии с
          a.ml-2(
            :to="{ name: 'ConstructorDocumentView', params: { id: agreementId }}"
          ) политикой обработки персональных данных
        span(v-else) Согласия слушателей на обработку персональных данных,
          |  в том числе указания их персональных данных в договоре получены
  v-checkbox.ml-2(
    v-model="confirmBox"
    :disabled="disabledBox"
    @change="$emit('change', $event)"
  )
    template(#label)
      span(v-if="noStep") Подтверждаю согласие на заключение представленного договора-оферты
        |  в соответствии с предусмотренным им порядком его заключения
      span(v-else) Подтверждаем согласие на заключение договора оферты в соответствии
        |  с порядком, предусмотренным предусмотренным договором-офертой
</template>
<script>
export default {
  props: {
    agreementId: { type: Number, default: null },
    readyContract: { type: Object, default: null },
    contract: { type: Object, default: null },
    price: { type: Number, default: null },
    noStep: { type: Boolean, default: false },
  },
  data() {
    return {
      checkbox: false,
      confirmBox: false,
      downloaded: false,
      isIntersect: false,
    };
  },
  computed: {
    disabledBox() {
      const check = this.noStep ? !this.checkbox : true;
      return this.contract && this.contract.is_offer
        ? !this.isIntersect && check : !this.downloaded && check;
    },
  },
  watch: {
    contract() {
      this.isIntersect = false;
      this.confirmBox = false;
    },
  },
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.isIntersect = true;
      }
    },
    download() {
      this.downloaded = true;
      window.open(this.contract.document.url);
    },
  },
};
</script>
